// GPH Expert Intelligence Core — Truth Policy (PDS §5.1, §13 do follow-up).
// Validação final antes de renderizar: o GPH só afirma o que tem evidência.
//   - pesquisou → só se researched=true COM fontes reais;
//   - encontrou vídeo → só se o provider retornou URL real;
//   - analisou vídeo → só se videoProcessed=true;
//   - sem evidência → incerteza controlada, nunca invenção.

const isRealUrl = (url) =>
  typeof url === 'string' && (url.startsWith('https://') || url.startsWith('http://'));

// Sanitiza um ResearchBackedAnswer vindo do backend (defesa em profundidade:
// mesmo que o backend já seja honesto, o frontend re-valida).
export const sanitizeResearchAnswer = (answer) => {
  const violations = [];
  if (!answer || typeof answer !== 'object') {
    return {
      valid: false,
      violations: ['missing_answer'],
      sanitized: { researched: false, sources: [], supportMaterial: null, synthesis: null, providerStatus: 'unavailable' }
    };
  }

  const sources = (Array.isArray(answer.sources) ? answer.sources : [])
    .filter((s) => s && isRealUrl(s.url) && s.title);

  let supportMaterial = answer.support_material || answer.supportMaterial || null;
  if (supportMaterial && !isRealUrl(supportMaterial.url)) {
    violations.push('support_material_without_real_url');
    supportMaterial = null;
  }

  let researched = answer.researched === true;
  if (researched && sources.length === 0 && !supportMaterial) {
    violations.push('researched_claim_without_sources');
    researched = false;
  }

  return {
    valid: violations.length === 0,
    violations,
    sanitized: {
      researched,
      providerStatus: answer.provider_status || answer.providerStatus || 'unavailable',
      synthesis: researched ? (answer.synthesis || null) : null,
      sources,
      supportMaterial,
      overallConfidence: Number(answer.overall_confidence ?? answer.overallConfidence ?? 0.5)
    }
  };
};

// Bloqueia validação de vídeo fabricada (PDS §12.2).
export const validateVideoValidationClaim = (validationResult) => {
  if (!validationResult) return { allowed: false, reason: 'missing_result' };
  if (validationResult.videoProcessed !== true) {
    return { allowed: false, reason: 'video_not_processed' };
  }
  return { allowed: true, reason: 'ok' };
};

// Decide o aviso de incerteza adequado quando não há evidência suficiente.
export const uncertaintyNotice = (copy, { dependsOnPatch = false } = {}) =>
  dependsOnPatch ? copy.uncertaintyPatch : copy.uncertaintyLow;

const truthPolicy = { sanitizeResearchAnswer, validateVideoValidationClaim, uncertaintyNotice };

export default truthPolicy;
